import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup } from "reactstrap";
import { baseURL } from "../../../../Services/api/baseURL";

const PointsModal = ({onSuccess ,userId, isOpen,isAdd, toggle }) => {
  const [points, setPoints] = useState("");
  const [reason, setReason] = useState("");

  const handleSubmit = async () => {
    console.log({isAdd, points, reason });
    
    toggle(); 

    try {
        const token = JSON.parse(localStorage.getItem("token"));
  if (!points || reason.trim() === "") {
      return toast.warn("Please fill in all fields");
    }
    const url = isAdd 
      ? `${baseURL}/api/admin/add-point` 
      : `${baseURL}/api/admin/deduct-point`;

    const res = await axios.post(
      url,
      {userId, points, reason }, // request body
      { headers: { Authorization: token } } // headers
    );
    toast.success(res.data.message || "Success");
    toggle(); 
    setPoints("")
    setReason("")
      if (onSuccess) onSuccess(); 

  } catch (error) {
    console.error(error);
    toast.error("Failed to submit request");
  }
};

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
<ModalHeader className="text-[#d3178a]" toggle={toggle}>
  <span className="font-bold">
    {isAdd ? "Add" : "Deduct"} Points
  </span>
</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="points">Points</Label>
          <Input
            type="number"
            id="points"
            value={points}
            onChange={(e) => setPoints(e.target.value)}
            placeholder="Enter points"
          />
        </FormGroup>
        <FormGroup>
          <Label for="reason">Reason</Label>
          <Input
            type="text"
            id="reason"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="Enter reason"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={handleSubmit}>
          Submit
        </Button>
        <Button color="danger" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PointsModal;
